<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table #importTable (detail)="onDetail($event)" (edit)="onEdit($event)" (remove)="onRemove($event)"
    [columns]="columns" [dataProviderParams]="params" [dataProvider]="pipeImportService" [title]="'Imports'"></data-table>
</page-content>
